"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOMENTJS_ISO_WITHOUT_THE_ZED_STRING_FORMAT = void 0;
exports.MOMENTJS_ISO_WITHOUT_THE_ZED_STRING_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
//# sourceMappingURL=momentFormats.js.map